<!--
FigureCaption - a Nuxt.js NuxtContent component from Pennock Projects, MIT License, Copyright (c) 2025-2026 John Pennock
version: 1.0
-->

<template>
  <div class="figure-all">
    <figure class="figure-image not-prose">
      <slot />
    </figure>
    <figcaption v-if="$slots.caption" class="caption-container">
      <slot name="caption" />
    </figcaption>
  </div>
</template>

<style scoped>
.figure-all {
  @apply p-2 m-0 w-full
}

.caption-container {
  @apply my-2 text-sm text-center md:text-lg italic font-bold text-gray-800 dark:text-gray-200
}

.figure-image :deep(img) {
  max-width: 100%;
  object-fit: contain;
  @apply mx-auto my-auto sm:h-[30vh]
}

</style>